import "../scss/bundle.scss"
import barba from '@barba/core'
import barbaPrefetch from '@barba/prefetch'
import LocomotiveScroll from 'locomotive-scroll'
import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger)
import {detectedDevice} from 'detected-device'
import SimpleBar from 'simplebar'
import Swiper from 'swiper'
// import flubber from "flubber"
import { interpolate } from "flubber"

//Internal
import {Header} from './Header'
import {SVGRoundedButtons} from './SVGRoundedButtons'
import {ScrollDown} from './ScrollDown'
import {NavigationBar} from './NavigationBar'
import {Menu} from './Menu'
import {LoginPopup} from './LoginPopup'
import {Search} from './Search'
import {HoverReveal} from './HoverReveal'
import {Minicart} from './Minicart'
import {Product} from './Product'
import {InfiniteWall} from './InfiniteWall'
// import {Articolo} from './Articolo'
import {SwiperSlideShow, SwiperSlideShowMobile, SwiperProductFeed} from './SwiperSlideShow'
import {Form} from './Form'
import {CustomCursor} from './CustomCursor'
// import {NavbarDraggable} from './NavbarDraggable'
import {AjaxFilters} from './AjaxFilters'
import {Checkout} from './Checkout'
import {MyAccount} from './MyAccount'
import {Loader} from './Loader'
import {StoreLocator} from './StoreLocator'
import {Goals} from './Goals'
import {EventiFestival} from './EventiFestival'
import {CookiePopup} from './CookiePopup'
import {CustomDatalayer} from './CustomDatalayer'

let homeUrl = document.getElementById('homeUrl').value

let cursor

// let hamburger = null
let menuClass = null
let loginPopupClass = null
let searchClass = null
let headerClass = null
let infiniteWallClass = null
let navbarDraggableClass = null
let productClass = null
let loaderClass = null
let customDatalayerClass = null

let awdScroll = null
let animations = null
let deltaDirection = 1

let language = document.getElementById('currLang').getAttribute('data-lang')

let namespaceStoria = 'storia'
let namespaceRegistrazione = 'registrazione'
let namespaceContatti = 'contatti'
let namespaceContatti2 = 'contatti-2'
if(language !== 'it'){
    namespaceStoria = 'history'
    namespaceRegistrazione = 'registration'
    namespaceContatti = 'contact'
}

let minicart = null

let colors = {
    black: '#000',
    white: '#fff',
    // panna: '#efe6e2',
    greyDark: '#121213',
    // panna: 'rgb(239, 238, 233)',
    panna: 'rgb(231, 228, 216)',
    // panna: '#c2bea0',
    error: '#c42323',
    success: '#188a18',
    tiffany: '#81D8D0'
}
// console.log(document.documentElement.style)

//Devices
let isMobile = detectedDevice.isMobile()
let isSmallTablet = detectedDevice.isSmallTablet()
let isBigTablet = detectedDevice.isBigTablet()
let isAllTablet = detectedDevice.isAllTablet()
let isAllMobileDevices = detectedDevice.isAllMobileDevices()


let winsize = {
    width: window.innerWidth,
    height: window.innerHeight
}
function calcWinsize() {
    return { width: window.innerWidth, height: window.innerHeight }
}
winsize = calcWinsize()

window.addEventListener('resize', () => {
    winsize = calcWinsize()
    isMobile = detectedDevice.isMobile()
    isSmallTablet = detectedDevice.isSmallTablet()
    isBigTablet = detectedDevice.isBigTablet()
    isAllTablet = detectedDevice.isAllTablet()
    isAllMobileDevices = detectedDevice.isAllMobileDevices()
})

let mousePos = {
    x:winsize.width/2,
    y:winsize.height/2
}

const getMousePos = (ev) => {
    let posx = 0;
    let posy = 0;
    if (!ev) ev = window.event;
    if (ev.pageX || ev.pageY) {
        posx = ev.pageX;
        posy = ev.pageY;
    }
    else if (ev.clientX || ev.clientY) 	{
        posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
        posy = ev.clientY + body.scrollTop + docEl.scrollTop;
    }
    return {x: posx, y: posy};

}
window.addEventListener('mousemove', e => {
    mousePos = getMousePos(e);
})

const validateEmail = (email) => {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
function validDigits(n) {
    return n.replace(/[^0-9]+/g, '');
}

// Aggiornamento delle classi del body
function setBodyClass(data){
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi
    let match = regexp.exec(data.next.html)
    if (!match || !match[1]) {
        // If no body class, remove it
        document.body.setAttribute("class", "")
    }
    else {
        // Set the new body class
        document.body.setAttribute("class", match[1])
    }
}

function setLanguage(data){
    let translatedUrl = data.next.container.getAttribute('data-translated-url')
    let linguaCorrente = data.next.container.getAttribute('data-language')
    let itemsLingua = document.querySelectorAll('.item-lingua-selezionabile span')

    itemsLingua.forEach( itemLingua => {
        let a = itemLingua.closest('a')
        a.setAttribute('href', translatedUrl)
        itemLingua.innerHTML = linguaCorrente === 'it' ? 'en' : 'it'
    })

}

function updateDeltaOnScroll(instance){
    document.querySelector('body').setAttribute('data-scroll-y', instance.scroll.y)
    document.querySelector('body').setAttribute('data-scroll-x', instance.scroll.x)
    if(instance.direction === 'up' || instance.direction === 'left'){
        deltaDirection = -1
    }
    else{
        deltaDirection = 1
    }
    return deltaDirection
}
//Funzione richiamata in functions.php (con wp_register_scripts) per evitare l'errore "Loading the Google Maps JavaScript API without a callback is not supported"
// function avoidCallbackError(){
//     console.log('map')
// }
// avoidCallbackError()
    // console.log('google: ', google )
let _animations = () => {
    awdScroll.on('call', (value, way, obj) => {
        if(value == 'updateScroll'){
            let el = obj.el;
            if(!el.classList.contains('once')){
                el.classList.add('once')
                awdScroll.update();

            }
        }

        if(value == 'svg-connector'){
            let el = obj.el
            let svgConnectorHorizontal = el.querySelector('.svg-connector-h')
            let svgConnectorVertical = el.querySelector('.svg-connector-v')
            if(!el.classList.contains('once')){
                el.classList.add('once')
                gsap.to(svgConnectorVertical,{
                    duration:2.4,
                    attr: { y2: "234.6" },
                    ease:'power2.out'
                })
                gsap.to(svgConnectorHorizontal,{
                    duration:0.6,
                    attr: { x1: "10.5" },
                    ease:'power2.out'
                })
            }
        }

        if(value == 'svg-connector-short'){
            let el = obj.el
            let svgConnectorHorizontal = el.querySelector('.svg-connector-h')
            let svgConnectorVertical = el.querySelector('.svg-connector-v')
            if(!el.classList.contains('once')){
                el.classList.add('once')
                gsap.to(svgConnectorVertical,{
                    duration:2.4,
                    attr: { y2: "154.6" },
                    ease:'power2.out'
                })
                gsap.to(svgConnectorHorizontal,{
                    duration:0.6,
                    attr: { x1: "10.5" },
                    ease:'power2.out'
                })
            }
        }

        if(value == 'fadeUp'){
            let el = obj.el;
            let image = el.querySelectorAll('.fadeUp-el')
            if(!el.classList.contains('once')){
                el.classList.add('once')
                gsap.to(image,{
                    duration:1.3,
                    autoAlpha:1,
                    ease:'power1.in'
                });
                gsap.to(image,{
                    duration:1.3,
                    y:0,
                    ease:'power2.out',
                    // delay:delay
                });

            }
        }

        // if(value == 'fade-in'){
        //     let el = obj.el;
        //     let image = el.querySelectorAll('.fade-in-el')
        //     if(!el.classList.contains('once')){
        //         el.classList.add('once')
        //         gsap.to(image,{
        //             duration:1.2,
        //             autoAlpha:1,
        //             ease:'power2.in'
        //         });
        //         gsap.to(image,{
        //             duration:1.2,
        //             y:0,
        //             ease:'power3.out',
        //             // delay:delay
        //         });

        //     }
        // }

        // if(value == 'stagger-up-animation'){
        //     let el = obj.el;
        //     // console.log(el)
        //     let delay = 0;
        //     if(!el.classList.contains('once')){
        //         el.classList.add('once')
        //         el.querySelectorAll('.stagger-up-element').forEach( item => {
        //             gsap.to(item,{
        //                 duration:1.2,
        //                 y:0,
        //                 ease:'power2.out',
        //                 delay:delay
        //             });
        //             gsap.to(item,{
        //                 duration:1.2,
        //                 opacity:1,
        //                 ease:'power1.in',
        //                 delay:delay
        //             });
        //             delay += 0.1;
        //         })

        //     }
        // }
    })

}



const siparioTransition = document.querySelector(".sipario-transition")
const svgBgPathGold = siparioTransition.querySelector(".svg-sipario-transition-gold__path")
const svgBgPathWhite = siparioTransition.querySelector(".svg-sipario-transition-white__path")
const siparioPageNameWrapper = siparioTransition.querySelector(".sipario-page-name__wrapper")
const siparioPageNameElJs = siparioTransition.querySelector(".page-name-js")
//Transizione di pagina: entra sipario
function pageTransitionBeforeLeave(){
    return new Promise( resolve => {
        setTimeout( () => {
            awdScroll.scrollTo(0,{
                duration: 0 //ms
            })   

        },800)       
        gsap.set(siparioTransition,{
            display: 'block'
        })
        gsap.
            timeline({onComplete: () => resolve()})
                .set(svgBgPathGold, {
                    attr: { d: "M 0 100 V 100 Q 50 100 100 100 V 100 z" }
                  })
                  .to(
                    svgBgPathGold,
                    {
                        attr: { d: "M 0 100 V 65 Q 50 0 100 65 V 100 z" },
                        ease: "power1.in",
                        duration: 0.5
                    },
                    0
                  )
                  .to(svgBgPathGold, {
                    attr: { d: "M 0 100 V 0 Q 50 0 100 0 V 100 z" },
                    ease: "power2.out",
                    duration: 0.5
                  })

    })

}
// function pageTransitionAfterLeave(nextContainer){
//     return new Promise(resolve => {

//         // siparioPageNameElJs.innerHTML = nextContainer.getAttribute('data-title')

//         //Mostro il titolo fake della pagina
//         // gsap.set(siparioPageNameWrapper,{
//         //     y: 0,
//         //     autoAlpha:1,
//         //     scale: 0.2
//         // })


//         // mostro svg bianco
//         // gsap.
//         //     timeline({onComplete: () => resolve()})
//         //         .set(svgBgPathWhite, {
//         //             attr: { d: "M 0 100 V 100 Q 50 100 100 100 V 100 z" }
//         //           })
//         //           .to(
//         //             svgBgPathWhite,
//         //             {
//         //                 attr: { d: "M 0 100 V 65 Q 50 0 100 65 V 100 z" },
//         //                 ease: "power1.in",
//         //                 duration: 0.6
//         //             },
//         //             0
//         //           )
//         //           .to(svgBgPathWhite, {
//         //             attr: { d: "M 0 100 V 0 Q 50 0 100 0 V 100 z" },
//         //             ease: "power2.out",
//         //             duration: 0.6
//         //           })
//         resolve()

//     })

// }

//Transizione di pagina: esce sipario
function pageTransitionBeforeEnter(data){
        
    return new Promise( resolve => {
        // console.log('page transition before enter')
        const bgPageColor = getComputedStyle(document.querySelector('body')).backgroundColor
        if(bgPageColor === colors.panna){
            headerClass.toAlternativeColor()
            // console.log('header bg deve essere panna')
        }
        else{
            headerClass.toDefaultColor()
            // console.log('header bg deve essere scruro')
        }
        // console.log('header bg')
        // let header = document.querySelector('header')
        headerClass.header.classList.add('active')
        gsap.to(headerClass.headerBg,{
            duration: 0.2,
            opacity: 0,
        })         
        let timelineDelay = 1.2
        //Esce svg gold
        gsap.
            timeline({delay: timelineDelay})
                  .set(svgBgPathGold, {
                        attr: { d: "M 0 0 V 100 Q 50 100 100 100 V 0 z" }
                    })
                    .to(
                      svgBgPathGold,
                      {
                          attr: { d: "M 0 0 V 35 Q 50 0 100 35 V 0 z" },
                          ease: "power1.in",
                          duration: 0.5
                      }
                    )
                    .to(
                      svgBgPathGold,
                      {
                          attr: { d: "M 0 0 V 0 Q 50 0 100 0 V 0 z" },
                          ease: "power2.out",
                          duration: 0.5,
                          onComplete: () => {
                            //reset svg gold
                            gsap.set(svgBgPathGold,{
                                attr: { d: "M 0 100 V 100 Q 50 100 100 100 V 100 z" }
                            })
                            resolve()
                          }
                      }
                    )
        
    })
}

function hoverSostenibilitaHomepage(data){
    let nextContainer = data.next.container
    let sezioneSostenibilita = nextContainer.querySelector('.sezione-sostenibilita')
    let items = [...sezioneSostenibilita.querySelectorAll('.item-sostenibilita')]
    let titles = [...sezioneSostenibilita.querySelectorAll('.title-sostenibilita')]

    items.forEach(item => {
        item.addEventListener('mouseenter', () => {
            const label = item.getAttribute('data-label')
            titles.forEach(title => {
                if(title.getAttribute('data-label') !== label){
                    TweenMax.to(title,0.3, {
                        autoAlpha: 0
                    })
                }
                else{
                    TweenMax.to(title,0.3, {
                        autoAlpha: 1
                    })
                }
            })
        })
        item.addEventListener('mouseleave', () => {
            // const label = item.getAttribute('data-label')
            titles.forEach(title => {
                TweenMax.to(title,0.3, {
                    autoAlpha: 0
                })
            })
        })
    })

}

function riseAndFadeIn(el,args){
    let defaults = {duration: 1.2, destination: 0, delay: 0}
    let params = {...defaults, ...args}
    gsap.to(el, {
        duration: params.duration,
        delay: params.delay,
        autoAlpha: 1,
        ease: 'power1.in'
    })
    gsap.to(el, {
        duration: params.duration,
        delay: params.delay,
        y: params.destination,
        ease: 'power2.out'
    })
}
function riseAndFadeOut(el,args){
    let defaults = {duration: 0.6, destination: 40, delay: 0}
    let params = {...defaults, ...args}
    gsap.to(el, {
        duration: params.duration,
        delay: params.delay,
        autoAlpha: 0,
        y: params.destination
    })
}

const setAPILanguage = (lang, libraries, key) => {
    //Destroy old API
    document.querySelectorAll('script[src^="https://maps.googleapis.com"]').forEach(script => {
      script.remove();
    });
    // if(google) delete google.maps;
  
    //Generate new Google Maps API script
    let newAPI = document.createElement('script');
    newAPI.src = 'https://maps.googleapis.com/maps/api/js?libraries=' + libraries.join(',') + '&key=' + key + '&language=' + lang + '&callback=googleMapsAPILoaded';
  
    //Callback for the Google Maps API src
    window.googleMapsAPILoaded = () => {
      let event = new CustomEvent('googleMapsAPILoaded');
      window.dispatchEvent(event);
    }
  
    //Wait for the callback to be executed
    let apiLoaded = new Promise(resolve => {
      window.addEventListener('googleMapsAPILoaded', () => {
        resolve();
      });
    });
  
    //Start the script
    document.querySelector('head').appendChild(newAPI);
  
    return apiLoaded;
}

function hoverIcons(){
    // let hamburger = document.querySelector('.hamburger')
   
    // hamburger.addEventListener('mouseover', () => {
    //     menuClass.openHamburgerIcon()
    // }) 
    // hamburger.addEventListener('mouseleave', () => {
    //     if(hamburger.classList.contains('opened')) return
    //     menuClass.closeHamburgerIcon()
    // })    
    

    let bottiglia = document.querySelector('header .bottiglia')
    let objVinoBottiglia = {m1:3, m2:42, c1:0, c2:0, c3:0, c4:0, c5:0, c6:0, L1:17, L2:42, v1:0, H1:3, V1:15}
    let svgVinoBottiglia = bottiglia.querySelector('.svg-vino-bottiglia')
    bottiglia.addEventListener('mouseover', () => {
        gsap.to(objVinoBottiglia, {
            duration: 0.6,
            ease:'power2.out',
            m1:3, m2:15, c1:4.1, c2:1.9, c3:8.9, c4:3, c5:13.1, c6:0.3, L1:17, L2:15, v1:27, H1:3, V1:15,
            onUpdate: () => {
                svgVinoBottiglia.setAttribute('d', `M${objVinoBottiglia.m1},${objVinoBottiglia.m2}c${objVinoBottiglia.c1},${objVinoBottiglia.c2},${objVinoBottiglia.c3},${objVinoBottiglia.c4},${objVinoBottiglia.c5},${objVinoBottiglia.c6}L${objVinoBottiglia.L1},${objVinoBottiglia.L2}v${objVinoBottiglia.v1}H${objVinoBottiglia.H1}V${objVinoBottiglia.V1}z`)
            }
        })
    }) 
    bottiglia.addEventListener('mouseleave', () => {
        gsap.to(objVinoBottiglia, {
            duration: 0.6,
            ease:'power2.out',
            m1:3, m2:42, c1:0, c2:0, c3:0, c4:0, c5:0, c6:0, L1:17, L2:42, v1:0, H1:3, V1:15,
            onUpdate: () => {
                svgVinoBottiglia.setAttribute('d', `M${objVinoBottiglia.m1},${objVinoBottiglia.m2}c${objVinoBottiglia.c1},${objVinoBottiglia.c2},${objVinoBottiglia.c3},${objVinoBottiglia.c4},${objVinoBottiglia.c5},${objVinoBottiglia.c6}L${objVinoBottiglia.L1},${objVinoBottiglia.L2}v${objVinoBottiglia.v1}H${objVinoBottiglia.H1}V${objVinoBottiglia.V1}z`)
            }
        })
    })   

    let actionPrenota = document.querySelector('.action-prenota--desktop')
    let objPrenota = {m1:17, m2:21, C1:17, C2:21, C3:5, C4:21, C5:5 , C6:21, h1:24, C7:29, C8:21, C9:17, C10:21, C11:17, C12:21}
    let svgPrenota = actionPrenota.querySelector('.svg-fill-campanello')
    actionPrenota.addEventListener('mouseover', () => {
        gsap.to(objPrenota, {
            duration: 0.6,
            ease:'power2.out',
            m1:17, m2:9, C1:10.4, C2:9, C3:5, C4:14.4, C5:5, C6:21, h1:24, C7:29, C8:14.4, C9:23.6, C10:9, C11:17, C12:9,
            onUpdate: () => {
                svgPrenota.setAttribute('d', `M${objPrenota.m1},${objPrenota.m2}C${objPrenota.C1},${objPrenota.C2},${objPrenota.C3},${objPrenota.C4},${objPrenota.C5},${objPrenota.C6}h${objPrenota.h1}C${objPrenota.C7},${objPrenota.C8},${objPrenota.C9},${objPrenota.C10},${objPrenota.C11},${objPrenota.C12}z`)
            }
        })
    }) 
    actionPrenota.addEventListener('mouseleave', () => {
        gsap.to(objPrenota, {
            duration: 0.6,
            ease:'power2.out',
            m1:17, m2:21, C1:17, C2:21, C3:5, C4:21, C5:5 , C6:21, h1:24, C7:29, C8:21, C9:17, C10:21, C11:17, C12:21,
            onUpdate: () => {
                svgPrenota.setAttribute('d', `M${objPrenota.m1},${objPrenota.m2}C${objPrenota.C1},${objPrenota.C2},${objPrenota.C3},${objPrenota.C4},${objPrenota.C5},${objPrenota.C6}h${objPrenota.h1}C${objPrenota.C7},${objPrenota.C8},${objPrenota.C9},${objPrenota.C10},${objPrenota.C11},${objPrenota.C12}z`)
            }
        })
    })   
}


class InputCoupon {
    constructor(input) {
        this.input = input
        this.inputField = this.input.querySelector('input')
        this.errorCheckContainer = this.input.closest('.error-check-container')
        this.label = this.input.closest('.form__row').querySelector('.label')
        this.labelError = this.errorCheckContainer.querySelector('.label__error')
        this.labelErrorSpan = this.labelError.querySelector('span')
        this.defaultLabelErrorTxt = this.labelErrorSpan.innerHTML
        this.duration = 0.4
        this.initEvents();

        this.isEmpty = true
    }

    initEvents() {

        let topFocus = '0%'
        if (this.inputField.value !== '') {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
                borderColor: colors.success
            });
            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus
            })
        }

        this.inputField.addEventListener('focus', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 3,
            })

            gsap.to(this.label, {
                duration: this.duration,
                top: topFocus
            })
            this.hideMessage()
        })
        this.inputField.addEventListener('blur', e => {
            gsap.to(this.input, {
                duration: this.duration,
                'border-bottom-width': 1,
            })
            if (this.inputField.value == '') {
                gsap.to(this.label, {
                    duration: this.duration,
                    top: '50%'
                })
            }
        })
    }

    resetField() {
        this.inputField.value = ''
        gsap.to(this.label, {
            duration: this.duration,
            top: '50%'
        })
    }


    checkIfIsEmpty() {
        let inputValue = this.inputField.value
        // let errorValue = ''
        //campo txt
        if (inputValue == '') {
            if (this.input.closest('.error-check-container') !== null) {
                this.resetMessage()
            }
            // let error = true
            // this.showMessage(error)
            this.isEmpty = true
        }
        else {
            this.isEmpty = false
            // this.hideMessage()
        }
    }

    resetMessage() {
        this.labelErrorSpan.style.color = colors.error
        this.labelErrorSpan.innerHTML = this.defaultLabelErrorTxt
    }

    showMessage(error) {
        if (error) {
            this.labelErrorSpan.style.color = colors.error
        }
        else {
            this.labelErrorSpan.style.color = colors.success
        }
        gsap.to(this.labelError, {
            duration: 0.2,
            autoAlpha: 1
        })
    }

    setMessage(message) {
        this.labelErrorSpan.innerHTML = message
    }

    hideMessage() {
        return new Promise(resolve => {
            gsap.to(this.labelError, {
                duration: 0.2,
                autoAlpha: 0,
                onComplete: () => {
                    resolve()
                }
            })
        })
    }
}


function setCookie(cookieName, duration = 60 * 60 * 1000 * 24 * 30){
    //imposto il cookie
    if (document.cookie.indexOf(cookieName) < 0) {
        var expiry = new Date()
        // var unMinuto = 60*1000
        // expiry.setTime(expiry.getTime()+(unMinuto/3)) //20 secondi
        // expiry.setTime(expiry.getTime()+(60*unMinuto)); //un'ora
        // expiry.setTime(expiry.getTime()+(60*unMinuto*24)); //un giorno
        // expiry.setTime(expiry.getTime()+(60*unMinuto*24*30)); //30 gg
        expiry.setTime(expiry.getTime()+duration); //30 gg

        //Creo il cookie 'visited' e lo setto a 'yes'. Infine ne imposto la scadenza
        document.cookie = cookieName+"=yes; expires=" + expiry.toGMTString()
        // setTimeout(function(){
            // popUp()
            // console.log('diff',difference)

        // },3000)
        // console.log(`cookie ${cookieName} impostato`)
    }
    //cookie esistente
    else{

    }
}

function updateCurrentMenuItem(data){
    // console.log(data)
    let nextId = data.next.container.dataset.id
    // let menuItems = [...document.querySelectorAll('#menu-submenu-servizi .menu-item')]
    let submenuItems = [...document.querySelectorAll('.submenu-item')]
    // console.log(menuItems)
    // let menuItemsMobile = [...document.querySelectorAll('.menu-mobile .menu-mobile__item')]
    let mainMenuItems = [...document.querySelectorAll('.main-menu-item')]
    let nextCurrentItem = data.next.container.getAttribute('data-current')
    submenuItems.forEach( item => {
        setTimeout( () => {
            item.classList.remove('current')
            let itemId = item.dataset.submenuItemId
            if(nextId === itemId){
                // console.log('itemId: ', itemId)
                item.classList.add('current')
            }
        },1400)
    })
    // mainMenuItems.forEach( item => {
    //     setTimeout( () => {
    //         item.classList.remove('current')
    //         let itemName= item.getAttribute('data-current')
    //         if(nextCurrentItem === itemName){
    //             // console.log('itemId: ', itemId)
    //             item.classList.add('current')
    //         }
    //     },1400)
    // })
    // menuItemsMobile.forEach( item => {
    //     item.classList.remove('current')
    //     let itemId = item.dataset.menuMobileItemId
    //     if(nextId === itemId){
    //         item.classList.add('current')
    //     }
    // })
}

function initLocomotiveScroll(direction){
    // console.log(direction)
    let scrollbarClass = 'awd-scrollbar'
    awdScroll = new LocomotiveScroll({
        el: document.querySelector('#scrollable'),
        smooth: true,
        getSpeed: true,
        getDirection: true,
        direction: direction,
        lerp: 0.1,
        scrollbarClass: scrollbarClass
    })
    // console.log(awdScroll)
    headerClass.updateScroller(awdScroll,direction)
    window.addEventListener('resize', () => {
        awdScroll.update()
        // console.log(awdScroll)
    })
    awdScroll.on('scroll', (instance) => {
        updateDeltaOnScroll(instance)
    })
    animations = _animations()

}

class FixedAppHeightInMobile {
    constructor() {
        this.appHeight()
    }
    init() {
        window.addEventListener('resize', () => {
            this.appHeight()
        })

        window.addEventListener('orientationchange', () => {
            this.appHeight()
        })
    }
    appHeight() {
        this.doc = document.documentElement
        this.doc.style.setProperty('--app-height', `${window.innerHeight}px`)
        // let containerHeight = document.getElementById('container').getBoundingClientRect().height
        // alert(containerHeight)
        // alert(window.innerHeight)
        //TODO: Check se serve decommentare
        // if(!document.body.classList.contains('page-template-cart')){
        //     doc.style.setProperty('--padding-bottom-mobile','0px')
        // }
        // else{
        //     let block = document.querySelector('.cart--total_block')
        //     let blockHeight = block.getBoundingClientRect().heigt
        //     doc.style.setProperty('--padding-bottom-mobile', `${blockHeight}px`)

        // }
    }
}

function enableLegalAgeButton(){
    if(document.querySelector('.btn-set-legal-age') !== null){
        let siparioMaggiorenne = document.querySelector('.sipario-maggiorenne')
        let btnSetLegalAge = document.querySelector('.btn-set-legal-age')
        btnSetLegalAge.addEventListener('click', () => {
            let legalAgeStorageObject = {
                value: "true",
                expiry: new Date().getTime()
            }
            localStorage.setItem("legal-age",JSON.stringify(legalAgeStorageObject))
            gsap.to(siparioMaggiorenne, {
                duration: 0.6,
                autoAlpha: 0,
                onComplete: () => {
                    new Loader()
                }
            })
        })
        // console.log(JSON.parse(localStorage.getItem("legal-age")).value)
    }
}

//Funzione esportata in Loader.js
function introHomepage(){
    // console.log('intro homepage')
    if(document.querySelector('.homepage') !== null){
        let delay = 0
        let header = document.querySelector('.header__wrapper')
        let heroSection = document.querySelector('.homepage .sezione-hero')
        let navigationBar = document.querySelector('.homepage .navigation__sections')
        let navigationCursor = document.querySelector('.homepage .navigation__cursor .img')
        heroSection.querySelectorAll('.stagger-up-element').forEach( item => {
            gsap.set(item,{
                opacity:0
            })
        })
        // console.log(window.innerWidth / 10)
        gsap.set(navigationBar,{
            x: window.innerWidth / 10
        })
        gsap.set(navigationCursor,{
            x: window.innerWidth / 10
        })
        // header.classList.remove('active')   
        gsap.set(header, {
            y: '-100%'
        })

        setTimeout( () => {
            heroSection.querySelectorAll('.stagger-up-element').forEach( item => {
                gsap.to(item,{
                    duration:1.2,
                    y:0,
                    ease:'power2.out',
                    delay:delay
                })
                gsap.to(item,{
                    duration:1.2,
                    opacity:1,
                    ease:'power1.in',
                    delay:delay,
                    onComplete: () => {
                    }
                })
                delay += 0.3
                
            })        
            setTimeout(() => {
                gsap.to(navigationBar,{
                    duration: 1,
                    ease: 'power2.out',
                    x: 0
                }) 
                gsap.to(navigationCursor,{
                    duration: 1,
                    ease: 'power2.out',
                    x: 0
                })     
            },1400)
            setTimeout(() => {
                header.classList.add('active')     
                gsap.to(header, {
                    duration: 1,
                    ease:'power2.out',
                    y: '0%'
                })
            },2200)

        },1000)
    }
}

document.addEventListener("DOMContentLoaded", function(){
    setTimeout( () => {
        // alert(detectedDevice.isMobile())
        // console.log(screen.width)
        // new Loader()
        if (!localStorage.getItem("legal-age")) {
            // console.log('local storage no impostato')
            gsap.to(document.querySelector('.sipario-maggiorenne__center'),{
                duration: 1.2,
                autoAlpha: 1
            })
            enableLegalAgeButton()
        }
        else{
            // console.log('local storage no impostato')
            let siparioMaggiorenne = document.querySelector('.sipario-maggiorenne')
            gsap.set(siparioMaggiorenne, {
                display:"none"
            })
            new Loader()
        }

        // if(!isAllMobileDevices){
        if(screen.width > 834 && screen.width !== 1024){

            SVGRoundedButtons(document.querySelector('.sipario-maggiorenne'))
            

            if (document.querySelector('.cookie-popup') !== null) {
                SVGRoundedButtons(document.querySelector('.cookie-popup'))
            }
            if (document.querySelector('header .svg-rounded-button') !== null) {
                SVGRoundedButtons(document.querySelector('header'))
            }
            if (document.querySelector('.login-popup .svg-rounded-button') !== null) {
                SVGRoundedButtons(document.querySelector('.login-popup'))
            }
            if (document.querySelector('.minicart .svg-rounded-button') !== null) {
                SVGRoundedButtons(document.querySelector('.minicart'))
            }
        }
        headerClass = new Header()

        let direction = 'vertical'
        initLocomotiveScroll(direction)

        // window.addEventListener('resize', () => {
        //     awdScroll.update()
        // })
        // awdScroll.on('scroll', (instance) => {
        //     updateDeltaOnScroll(instance)
        // })
        // animations = _animations()

        // setCookie('cookie-test')

        cursor = new CustomCursor()
        menuClass = new Menu()
        loginPopupClass = new LoginPopup()
        searchClass = new Search()
        new Form(document.querySelector('.form--login'))
        customDatalayerClass = new CustomDatalayer()


        if(document.querySelector('.hover-reveal--js-element') !== null){
            [...document.querySelectorAll('.hover-reveal--js-element')].forEach( item => {
                new HoverReveal(item);
            })
        }

        // if(document.querySelector('.page-single-product-vino') !== null){
        //     console.log('dom loaded')
        // }
        if(document.querySelector('.page-checkout') !== null && document.querySelector('.page-checkout .thankyou--page') === null){
            new Checkout()
        }
        if (document.querySelector('.page-account') !== null) {
            new MyAccount()
        }

        minicart = new Minicart()
        // clickFeedback()


        // if(!isAllMobileDevices){
        if(screen.width > 834 && screen.width !== 1024){
            hoverIcons()
        }

        if (isAllMobileDevices) {
            new FixedAppHeightInMobile()
        }

        // setCookie('_____test______', 20*1000)

        if(document.querySelector('.cookie-popup') !== null){
            new CookiePopup(document.querySelector('.cookie-popup'))
        }

    },100)


    //Gli hooks vengono chiamati sempre, non solo dopo una transizione
    barba.hooks.beforeLeave((data) => {

    })
    barba.hooks.afterLeave((data) => {
        // Aggiornamento delle classi del body
        setBodyClass(data)
        // Aggiornamento della lingua nel selettore del header
        setLanguage(data)
        //Classe di supporto per determinare se il link è diretto: viene inserita solo dopo la prima transizione, quindi se non è presente nel body è un link diretto
        document.body.classList.add("not-direct-link")

    })
    barba.hooks.beforeEnter((data) => {

        // console.log(data.next.container)
        let nextContainer = data.next.container
        // Se provengo dalla pagina storia (che è l'unica con scroll orizzontale) resetto la direzione a verticale
        if(data.current.namespace === namespaceStoria){
            awdScroll.destroy()
            let direction = 'vertical'
            initLocomotiveScroll(direction)
        }

        // if(document.querySelector('.click-feedback-el') !== null){
        //     let clickFeedbackElements = [...document.querySelectorAll('.click-feedback-el')]
        //     clickFeedbackElements.forEach( el => {
        //         el.addEventListener('click', () => {
        //             clickFeedback()
        //         })
        //     })
        // }

        // let nextContainer = data.next.container
        // if(nextContainer.querySelector('.click-feedback-el') !== null){
        //     let clickFeedbackElements = [...nextContainer.querySelectorAll('.click-feedback-el')]
        //     clickFeedbackElements.forEach( el => {
        //         el.addEventListener('click', () => {
        //             clickFeedback()
        //         })
        //     })
        // }



        // if(isAllMobileDevices){
        //     if (document.querySelector('.slider-mobile-swiper') !== null) {
        //         [...document.querySelectorAll('.slider-mobile-swiper')].forEach(slider => {
        //             new SlideshowMobile(slider)
        //         })
        //     }
        // }

        // if(nextContainer.querySelector('.hover-reveal--js-element') !== null){
        //     [...nextContainer.querySelectorAll('.hover-reveal--js-element')].forEach( item => {
        //         new HoverReveal(item);
        //     })
        // }

    })
    barba.hooks.enter((data) => {
        // console.log('barba.hooks enter: ', data)
    })
    barba.hooks.afterEnter((data) => {
        let nextContainer = data.next.container
        //!Importante
        setTimeout(() => {
            awdScroll.update()
        }, 200)



        setTimeout( () => {
            updateCurrentMenuItem(data)
            // if(!isAllMobileDevices){
            if(screen.width > 834 && screen.width !== 1024){
                cursor.setCustomCursor(nextContainer)
                if (nextContainer.querySelector('.svg-rounded-button') !== null) {
                    SVGRoundedButtons(nextContainer)
                }
            }

            if(nextContainer.querySelector('.form--newsletter') !== null){
                new Form(nextContainer.querySelector('.form--newsletter'))
            }

        },200)


    })



    //Disabilito il prefetch perchè i link sembrano lenti se è attivo
    // barba.use(barbaPrefetch)
    barba.init({
        timeout: 10000,
        preventRunning: true,
        debug: false,
        prevent: ({ el }) => el.classList && el.classList.contains('barba-prevent'),
        transitions: [{
            before: (data) => {
                return new Promise(resolve => {
                    if(!document.querySelector('body').classList.contains('destination-page-product')){
                        //Se sono nella pagina product vino chiudo il feed prima di lasciare la pagina
                        if(document.querySelector('.page-single-product-vino')){
                            
                            //Disattivato dopo che ho spostato l'header feed vino dentro all'header    
                            // headerClass.chiudiHeaderFeedVino()
                        }
                        pageTransitionBeforeLeave().then( () => {
                            // awdScroll.scrollTo(0,{
                            //     duration: 0.1 //ms
                            // })               
                            //Questo setTimeout è importante perchè evita che gli elementi con data-scroll che si trovano above the fold prendano l'inview in anticipo       
                            setTimeout(() => {
                                resolve()
                            },500)      
                        })
                    }
                    else{             
                        //Questo setTimeout è importante perchè evita che gli elementi con data-scroll che si trovano above the fold prendano l'inview in anticipo  
                        setTimeout(() => {
                            resolve()
                        },500)    
                    }
                });
            },
            beforeLeave: (data, i) => {
                return new Promise(resolve => {
                    //Se sono nella pagina shop wall il click sul prodotto ha una transizione a sè stante
                    if(!document.querySelector('body').classList.contains('destination-page-product')){
                        // pageTransitionBeforeLeave()
                        // .then( () => {
                            if(minicart.minicart.classList.contains('opened')){
                                minicart.close()
                                let header = document.querySelector('header')
                                header.classList.add('active')
                                header.classList.remove('header-bloccato') 
                            }
                            if(menuClass.menu.classList.contains('popup-active')){
                                menuClass.closeMenu()
                                menuClass.closeHamburgerIcon()
                            }
                            if(searchClass.searchPage.classList.contains('popup-active')){
                                searchClass.closeSearch()
                            }
                            if(loginPopupClass.loginPopup.classList.contains('popup-active')){
                                loginPopupClass.closeLoginPopup()
                            }
                            // awdScroll.scrollTo(0,{
                            //     duration: 0.1 //ms
                            // })
                            resolve()
                        // })
                    }
                    else{
                        resolve()
                    }
                })
            },
            // leave: (data) => {
            //     return new Promise(resolve => {
            //         // console.log(data.next.container);
            //         resolve();
            //     });
            // },
            afterLeave: (data) => {                  
                const nextContainer = data.next.container
                return new Promise(resolve => {
                //     // updateLanguageLink(data.next.url.path)
                //     // setCurrentMenuItem(data)
                
                    // if(data.current.namespace !== 'shop-wall'){
                    //     pageTransitionAfterLeave(nextContainer).then( () => {
                    //         resolve()
                    //     })
                    // }
                    // else{
                    //     resolve()
                    // }
                    resolve()
                })
            },
            beforeEnter: (data) => {
                // const nextContainer = data.next.container
                console.log(data.next.namespace)
                return new Promise(resolve => {
                    let nextContainer = data.next.container
                    if(data.next.namespace === 'home'){
                        setTimeout(() => {
                            introHomepage()
                        }, 200)
                    }
                    //Aggiorno le dimensioni per la progress bar
                    headerClass.updateDimensionsForProgressBar()
                    document.querySelector('body').classList.remove('destination-page-product')
                    //Se provengo dalla pagina Shop Wall e vado verso un prodotto, non faccio la transizione di pagina
                    if(!isAllMobileDevices && data.current.namespace === 'shop-wall'){
                        // console.log('1')
                        if(data.next.namespace !== 'product'){
                            pageTransitionBeforeEnter(data)
                        }
                    }
                    else if(data.next.namespace === 'product'){
                        // console.log('2')
                        pageTransitionBeforeEnter(data)
                        
                        //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
                        // pageTransitionBeforeEnter(data).then(() => {
                        if(nextContainer.querySelector('.page-single-product-vino')){
                            headerClass.apriHeaderFeedVino()
                            let productId = nextContainer.getAttribute('data-id')
                            headerClass.ajaxRiempiFeedVino(productId).then(() => {
                                if(document.querySelector('.header-feed-vino') !== null){
                                    new SwiperProductFeed(document.querySelector('.swiper-slider-feed'))
                                }                            
                                //Disattivato dopo che ho spostato l'header feed vino dentro all'header      
                                // headerClass.apriHeaderFeedVino()

                            })
                        }  
                        // })
                    }
                    else{
                        // console.log('3')
                        pageTransitionBeforeEnter(data)
                    }
                    resolve()
                })
            },
            enter: (data) => {
                return new Promise(resolve => {             
                    //Importante perchè lo slider in homepage introduce degli awdScroll.stop() che possono bloccare lo scroll dopo le transizioni
                    awdScroll.start()
                    resolve()
                });
            },
            afterEnter: () => {
                return new Promise(resolve => {      
                    resolve()
                });
            },
            after: (data) => {


            }
        }],
        views: [ //beforeLeave - afterLeave - beforeEnter - afterEnter
            {
                namespace: 'home',
                beforeEnter(data){

                },
                afterEnter(data){
                    // console.log(data)
                    let nextContainer = data.next.container
                    setTimeout( () => {
                        // introHomepage()
                        new NavigationBar(nextContainer)
                        if(!isAllMobileDevices){
                            hoverSostenibilitaHomepage(data)
                        }
                        let sd = new ScrollDown(nextContainer.querySelector('.scroll-down'))
                        sd.updateScroller(awdScroll)

                        //Mobile
                        new SwiperSlideShowMobile(nextContainer.querySelector('.slider-swiper-mobile'))
                    },210)


                }
            },
            {
                namespace: 'product',
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        productClass = new Product(nextContainer, awdScroll, data)
                        
                        productClass.initAnimations()          
                        let sd = new ScrollDown(nextContainer.querySelector('.scroll-down'), winsize.height*1.8)  
                        sd.updateScroller(awdScroll)
                        let product_id = nextContainer.getAttribute('data-id')
                        customDatalayerClass.ajaxCall('view__item', {product_id}).then(res => {
                            console.log(product_id)
                            customDatalayerClass.singleProductDataLayer(res)
                        })
                        // if(document.querySelector('.header-feed-vino') !== null){
                        //     new SwiperProductFeed(document.querySelector('.swiper-slider-feed'))
                        // }

                        // if(nextContainer.querySelector('.page-single-product-vino')){
                        //     console.log('ok vado verso prodotto, apriHeaderFeedVino')
                            // productClass.apriHeaderFeedVino()
                        // }                        
                    },210)
                }
            },
            {
                namespace: 'product-visita',
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        productClass = new Product(nextContainer, awdScroll)
                        // productClass.initAnimations()          
                        // let sd = new ScrollDown(nextContainer.querySelector('.scroll-down'), winsize.height*1.8)  
                        // sd.updateScroller(awdScroll)
                    },210)
                }
            },
            {
                namespace: namespaceContatti,
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        let formContatti = nextContainer.querySelector('.form--contatti')
                        new Form(formContatti)
                    },210)
                }
            },
            {
                namespace: namespaceContatti2,
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        let formContatti = nextContainer.querySelector('.form--contatti')
                        new Form(formContatti)
                    },210)
                }
            },
            {
                namespace: 'shop',
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        // navbarDraggableClass = new NavbarDraggable(nextContainer)
                        new AjaxFilters(nextContainer)
                    },210)
                },
                beforeLeave(){
                    // navbarDraggableClass.dispose()
                },
            },
            {
                namespace: 'shop-wall',
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        infiniteWallClass = new InfiniteWall(nextContainer)
                    },210)
                },
                beforeLeave(){
                    infiniteWallClass.dispose()
                },
            },
            {
							namespace: 'news-cat',
							afterEnter(data){
								setTimeout( () => {
									let nextContainer = data.next.container
									nextContainer.querySelectorAll('.articolo').forEach((articolo, i) => {
										// new Articolo(articolo, i)
									})
								},210)
							}
            },
            {
							namespace: 'festival-franciacorta',
							afterEnter(data){
								setTimeout( () => {
									let nextContainer = data.next.container
									new EventiFestival(nextContainer, awdScroll)
								},210)
							}
            },
            // {
            //     namespace: 'agriturismo-villa-gradoni',
            //     afterEnter(data){
            //         setTimeout( () => {
            //             let nextContainer = data.next.container
            //             // if(!isMobile){
            //             //     new SwiperSlideShow(nextContainer.querySelector('.slider-swiper'))
            //             // }
            //             // else{
            //             //     let spaceBetween = 40
            //             //     new SwiperSlideShowMobile(nextContainer.querySelector('.slider-swiper'), spaceBetween)
            //             // }
            //         },210)
            //     }
            // },
            {
                namespace: namespaceRegistrazione,
                afterEnter(data){
                    setTimeout( () => {
                        // console.log('jjjdj')
                        let nextContainer = data.next.container
                        let formRegistrazione = nextContainer.querySelector('.form--registrazione')
                        new Form(formRegistrazione)
                    },210)
                }
            },
            {
                namespace: namespaceStoria,
                afterEnter(data){
                    setTimeout( () => {
                        // console.log('namespace')
                        let nextContainer = data.next.container
                        awdScroll.destroy()
                        let direction = 'horizontal'
                        initLocomotiveScroll(direction)
                        new NavigationBar(nextContainer, 'horizontal')

                        let scrollTarget = winsize.width
                        if(isAllMobileDevices){
                            scrollTarget = winsize.height
                        }
                        let sd = new ScrollDown(nextContainer.querySelector('.scroll-down'), scrollTarget)
                        sd.updateScroller(awdScroll)
                    },210)
                } 
            },
            // {
            //     namespace: 'storia-2',
            //     afterEnter(data){
            //         setTimeout( () => {
            //             let nextContainer = data.next.container
            //             awdScroll.destroy()
            //             let direction = 'horizontal'
            //             initLocomotiveScroll(direction)
            //             new NavigationBar(nextContainer, 'horizontal')

            //             let scrollTarget = winsize.width
            //             if(isAllMobileDevices){
            //                 scrollTarget = winsize.height
            //             }
            //             let sd = new ScrollDown(nextContainer.querySelector('.scroll-down'), scrollTarget)
            //             sd.updateScroller(awdScroll)
            //         },210)
            //     }
            // },
            {
                namespace: 'store-locator',
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        let formStoreLocator = nextContainer.querySelector('.form--store-locator')
                        new Form(formStoreLocator)
                        setAPILanguage(language, ['places'], 'AIzaSyAxj5j2u2_upSILveP4YRjRWQpjPFsjvP4').then( ( ) => {
                            new StoreLocator(nextContainer)
                        })                        
                    },210)
                }
            },
            {
                namespace: 'goals',
                afterEnter(data){
                    setTimeout( () => {
                        let nextContainer = data.next.container
                        new Goals(nextContainer, awdScroll)                    
                    },210)
                }
            }
        ]

    })


})




export {winsize, mousePos, awdScroll, isAllMobileDevices, isMobile, riseAndFadeIn, riseAndFadeOut, validDigits, minicart, SimpleBar, barba, Swiper, colors, validateEmail, headerClass, language, SVGRoundedButtons, menuClass, loginPopupClass, searchClass, productClass, InputCoupon, homeUrl, setCookie, updateDeltaOnScroll, introHomepage, customDatalayerClass}
